import moment from "moment";
import pluralize from "pluralize";
import PropTypes from "prop-types";
import { Segment, Grid, Icon } from "semantic-ui-react";
import { useModal } from "common/hooks/use-modal";
import { Button } from "hireart-components";
import { ContractLengthModal } from "../ContractLengthModal";

export const ContractLengthDetails = ({
  startDate,
  endDate = "",
  token,
  isStaffingPartner,
}) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModal();
  const formattedStartDate = startDate
    ? moment(startDate).format("L")
    : "Not provided";

  const durationHeaderText = endDate
    ? pluralize(
        "month",
        moment(endDate).diff(moment(startDate), "months"),
        true
      )
    : formattedStartDate;

  const subHeaderText = endDate ? (
    <>
      <span>{formattedStartDate}</span>
      <Icon name="arrow right" className="is-left-margined-xsmall blue" />
      <span>{moment(endDate).format("L")}</span>
    </>
  ) : (
    "start date"
  );

  return (
    <Grid.Column>
      <ContractLengthModal
        hasModalOpen={isModalOpen}
        onModalClose={handleModalClose}
        startDate={startDate}
        endDate={endDate}
        token={token}
        isStaffingPartner={isStaffingPartner}
      />
      <Segment>
        <p className="heading">{durationHeaderText}</p>
        <p>{subHeaderText}</p>
        <hr />
        <div className="card-spacer">
          <Button
            className="termination-link is-not-padded"
            size="md"
            basic
            fluid
            onClick={handleModalOpen}
          >
            Edit
            <Icon name="chevron right" className="chevron-icon" />
          </Button>
        </div>
      </Segment>
    </Grid.Column>
  );
};

ContractLengthDetails.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  token: PropTypes.string.isRequired,
  isStaffingPartner: PropTypes.bool.isRequired,
};
